<template>
  <div class="grid gap-3">
    <l-range-input
      v-for="item in items"
      :key="item.field"
      v-model="report[item.field]"
      class="label:inline-flex label:gap-2 label:items-baseline label:mr-2"
      :name="item.field"
      :label="item.title"
      :help="item.description"
      v-bind="{ min, max }"
    >
      <template #label="{ label, value }">
        <span class="after:content-[':']">{{ label }}</span>

        <span class="font-medium text-blue dark:text-white whitespace-nowrap">
          {{ new Priority(value).label() }} interest
        </span>
      </template>
    </l-range-input>
  </div>
</template>

<script setup>
import LRangeInput from "@/components/inputs/LRangeInput.vue"
import { Priority } from "@/models/Priority"
import { computed } from "vue"
import { useJobs } from "@/composables/useJobs"

const report = defineModel({ type: Object, required: true })

const props = defineProps({
  hide: Number,
  min: { type: Number, default: Priority.NO },
  max: { type: Number, default: Priority.HIGH },
})

const { jobs } = useJobs()

const items = computed(() => {
  return jobs.filter(item => report.value[item.field] !== props.hide)
})
</script>
